// src/components/operationCenter/widgets/token/valuation/TwValuationInsightsWidget.tsx
import React from "react";
import type { WidgetProps, TokenWidgetConfig } from "@/types/dashboard";
import { TokenWidgetWrapper } from "../TokenWidgetWrapper";
import { TokenWidgetConfigPanel } from "../TokenWidgetConfig";
import ValuationInsightsCard from "@/components/tokenPage/valuation/ValuationInsightsCard";

const TwValuationInsightsWidget: React.FC<WidgetProps<TokenWidgetConfig>> = ({
  widget,
  onConfigChange,
}) => {
  const config = widget.config as TokenWidgetConfig;
  return (
    <TokenWidgetConfigPanel config={config} onConfigChange={onConfigChange} widgetType={widget.type}>
      <TokenWidgetWrapper ticker={config.ticker} providers={["fundamentals"]}>
        <ValuationInsightsCard />
      </TokenWidgetWrapper>
    </TokenWidgetConfigPanel>
  );
};

export default TwValuationInsightsWidget;
